/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ comment: NonNullable<unknown> }} Override_OverriddenInputs */



/**
* | output |
* | --- |
* | "Overridden: {comment}" |
*
* @param {Override_OverriddenInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const override_overridden = /** @type {((inputs: Override_OverriddenInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Override_OverriddenInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Modifié : ${i?.comment}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Anulado: ${i?.comment}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Substituído: ${i?.comment}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sovrascritto: ${i?.comment}`)
	return /** @type {LocalizedString} */ (`Overridden: ${i?.comment}`)
});